import { render, staticRenderFns } from "./InstructionsDetailed.vue?vue&type=template&id=68dcdb1c&"
import script from "./InstructionsDetailed.vue?vue&type=script&lang=js&"
export * from "./InstructionsDetailed.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsDetailed.vue?vue&type=style&index=0&id=68dcdb1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports